import { computed } from 'mobx';

import { currentDistance } from '../currentDistance';

const isShowAll = computed<boolean>(() => {
  return !currentDistance.id.get();
});

export { isShowAll };
